import axios from "axios";
import React, { useState , useEffect} from "react";

const PackageForm = ({ onClose, name }) => {
  console.log("name",name)
  const [formValues, setFormValues] = useState({
    website: "",
    packagetype: "",
    Name: "",
    Validation: "",
    Validity: "",
    price: "",
    offerprice: "",
    invitationCount: "",
    imageCount: "",
    videoCount: "",
    maxImageCount: "",
    drive: "",
    storage: "",
  });
      const [application, setApplication] = useState([]);
  
  useEffect(() => {
    if (name && typeof name === "object" && !Array.isArray(name)) {
      setFormValues((prev) => ({
        ...prev,
        ...name, // Populate existing data
      }));
    } else if (Array.isArray(name) && name.length > 0) {
      setFormValues((prev) => ({
        ...prev,
        ...name[0], // Use the first object in the array
      }));
    }
  }, [name]);
  
  const Data = {
    Invitd1: [
      { title: "Invitation Count", name: "invitationCount" },
      { title: "Image Count", name: "imageCount" },
     
    ],
    Invitd2: [
    
      { title: "Video Count", name: "videoCount" },
      { title: "Max Image Count", name: "maxImageCount" },
    ],
    Photopoint1: [
      { title: "Drive", name: "drive" },
    ],
    Photopoint2: [
      { title: "Storage", name: "storage" },
    ],
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValues = { ...formValues, [name]: value };

    // Auto-generate Name only if it's empty or when website/packagetype change
    if (name === "website" || name === "packagetype") {
      if (!formValues.Name || formValues.Name === `${formValues.website} ${formValues.packagetype}`) {
        updatedValues.Name =
          updatedValues.website && updatedValues.packagetype
            ? `${updatedValues.website} ${updatedValues.packagetype}`
            : "";
      }
    }

    // Restrict certain inputs to digits only
    if (
      [
        "Validity",
        "price",
        "offerprice",
        "invitationCount",
        "imageCount",
        "videoCount",
        "maxImageCount",
        "storage",
      ].includes(name) &&
      !/^\d*$/.test(value)
    ) {
      return;
    }

    setFormValues(updatedValues);
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    console.log(formValues);
    
  
    try {
        const response = await axios.post(`http://localhost:4000/adminpackage`, formValues);
        console.log('Response:', response.data);
    
        if (typeof onClose === 'function') {  // Use onClose
          console.log("Closing section...");
          onClose();  // Call the function
        } else {
          console.error("onClose is not a function");
        }
      } catch (error) {
        console.error('Error creating role:', error);
      }
  };
  const fetchRools = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getapplication`);
      console.log(response.data.application);

      if (Array.isArray(response.data.application)) {
        setApplication(response.data.application);
      } else {
        setApplication([]); // Ensure it's always an array
      }
    } catch (error) {
      console.error('Error fetching rools:', error);
      setApplication([]); // Handle error case
    }
  };


  useEffect(() => {
    fetchRools();
  }, []);
  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Create Package</h5>
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <div className="modal-body ">
        <form  id="formAuthentication" onSubmit={handleSubmit}>
       <div style={{display:"flex", gap:"2%", justifyContent:"space-between"}}>
       <div style={{width:"50%"}}>
         {/* Dynamic Name Label */}
         <div className="mb-2">
          <label htmlFor="Name" className="form-label">
            {formValues.website && formValues.packagetype
              ? `${formValues.website} ${formValues.packagetype} Name`
              : "Name"}{" "}
            <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="Name"
            name="Name"
            placeholder="Enter package Name"
            value={formValues.Name}
            onChange={handleChange}
            required
          />
        </div>

        {/* Package Type */}
        <div className="mb-2">
          <label className="form-label" htmlFor="packagetype">
            Package Type <span style={{ color: "red" }}>*</span>
          </label>
          <select
            id="packagetype"
            className="form-control mb-2"
            name="packagetype"
            value={formValues.packagetype}
            onChange={handleChange}
            required
          >
           
            <option value="">Select Type</option>
            <option value="Package">Package</option>
            <option value="AddOn">AddOn</option>
          </select>
        </div>

          {/* Price Input */}
          <div className="mb-2">
          <label htmlFor="price" className="form-label">
            Price <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="price"
            name="price"
            placeholder="Enter Price"
            value={formValues.price}
            onChange={handleChange}
            required
          />
        </div>

       
  {/* Dynamic Fields for 'Invitd' */}
  {formValues.website === "Invitd" &&
          Data.Invitd1.map((item) => (
            <div className="mb-2" key={item.name}>
              <label htmlFor={item.name} className="form-label">
                {item.title} <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id={item.name}
                name={item.name}
                placeholder={`Enter ${item.title}`}
                value={formValues[item.name]}
                onChange={handleChange}
                required
              />
            </div>
          ))}

{formValues.website === "Photopoint" &&
          Data.Photopoint1.map((item) => (
            <div className="mb-2" key={item.name}>
              <label htmlFor={item.name} className="form-label">
                {item.title} <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id={item.name}
                name={item.name}
                placeholder={`Enter ${item.title}`}
                value={formValues[item.name]}
                onChange={handleChange}
                required
              />
            </div>
          ))}
      

     
       </div>
       
<div style={{width:"50%"}}>
   {/* Website Selection */}
<div className="mb-2">
          <label className="form-label" htmlFor="website">
            Application <span style={{ color: "red" }}>*</span>
          </label>
          <select
            id="website"
            className="form-control mb-2"
            name="website"
            value={formValues.website}
            onChange={handleChange}
            required
          >
            <option value="">Select Application</option>
            <option value="Invitd">Invitd</option>
            <option value="Photopoint">Photopoint</option>
          </select>
        </div>
 
            {/* Validation Selection */}
<div className="mb-2">
  <label htmlFor="Validation" className="form-label">
  Validity <span style={{ color: "red" }}>*</span>
  </label>
  <div style={{display:"flex", gap:"1%", justifyContent:"space-between"}}>
    <div style={{width:"30%"}}>
    <input
            type="text"
            className="form-control"
            id="Validity"
            name="Validity"
            placeholder="Enter Validity in Numbers"
            value={formValues.Validity}
            onChange={handleChange}
            required
          />
    </div>
    <div style={{width:"70%"}}>
    <select
    id="Validation"
    className="form-control"
    name="Validation"
    value={formValues.Validation}
    onChange={handleChange}
    required
  >
    <option value="">Select Validity</option>
    <option value="Days">Days</option>
    <option value="Week">Week</option>
    <option value="Month">Month</option>
    <option value="Year">Year</option>
    {/* Hide "Till Package" if packagetype is "Package" */}
    {formValues.packagetype !== "Package" && (
      <option value="Till Package">Till Package</option>
    )}
    <option value="Never">Never</option>
  </select>
    </div>
  </div>
 
</div>
<div className="mb-2">
          <label htmlFor="offerprice" className="form-label">
            Offer Price
          </label>
          <input
            type="text"
            className="form-control"
            id="offerprice"
            name="offerprice"
            placeholder="Enter Offer Price"
            value={formValues.offerprice}
            onChange={handleChange}
          />
        </div>
        {/* Dynamic Fields for 'Invitd' */}
        {formValues.website === "Invitd" &&
          Data.Invitd2.map((item) => (
            <div className="mb-2" key={item.name}>
              <label htmlFor={item.name} className="form-label">
                {item.title} <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id={item.name}
                name={item.name}
                placeholder={`Enter ${item.title}`}
                value={formValues[item.name]}
                onChange={handleChange}
                required
              />
            </div>
          ))}

        {/* Dynamic Fields for 'Photopoint' */}
        {formValues.website === "Photopoint" &&
          Data.Photopoint2.map((item) => (
            <div className="mb-2" key={item.name}>
              <label htmlFor={item.name} className="form-label">
                {item.title} <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id={item.name}
                name={item.name}
                placeholder={`Enter ${item.title}`}
                value={formValues[item.name]}
                onChange={handleChange}
                required
              />
            </div>
          ))}
       {/* Offer Price Input */}

</div>
       </div>
       

        {/* Submit Button */}
        <div className="modal-footer">
          <button type="submit"  className="btn btn-primary" >Save</button>
          <button className="btn btn-secondary" onClick={onClose} >Cancel</button>
        </div>
      </form>
        </div>
      
      </div>
    </div>
  </div>
   
  );
};

export default PackageForm;
